module.exports = __webpack_public_path__ + "src/img/cookies/feature-small.0c545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/feature-small.jpg
// module id = 104
// module chunks = 0